import React, { useEffect, useState } from "react";
import "../BookService/bookservice.scss";
import {
	IonButton,
	IonCol,
	IonIcon,
	IonImg,
	IonInput,
	IonLabel,
	IonRow,
	IonText,
	isPlatform,
} from "@ionic/react";
import { connect } from "react-redux";
import { closeOutline, search, searchOutline } from "ionicons/icons";
import {
	getRecommendedServices,
	// withSearchGetRecommendations,
	saveServiceSearchData,
	storeCurrentLatLong,
	storeUserMapAddress,
	updateVehicleDefaultAddress,
	deleteAddress,
	setDefAddress,
	saveAddressRef,
	saveWorkshopStandard,
	addItemToCart,
	getCartItemsList,
} from "../../../Store/Actions";
import { RECOMMENDED_SERVICES } from "../../../constants";
import ServicePill from "./servicePill";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import * as constants from "../../../constants";
import { PageHeaderWithLoc } from "./pageHeadWithLoc";
import ScreenBanner from "../../../utils/screenBanner";
import "../../Portal/dashboard.scss";
import { ToastMessage } from "../../../utils/toastMessage";

export const useDebouncedEffect = (effect: any, delay: any, deps: any) => {
	const callback = React.useCallback(effect, deps);

	React.useEffect(() => {
		const handler = setTimeout(() => {
			callback();
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [callback, delay]);
};

export const BookService: React.FC = (props: any) => {
	const [state, setState] = useState<any>([]);
	const [searchTags, setSearchTags] = useState<any>([]);
	const [searchString, setSearchString] = useState("");
	const [catalogVehicleId, setCatalogVehicleId] = useState("");
	const inputRef = React.useRef<any>(null);
	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	var Tinder: any = null;
	const onTinderSwipe = () => {
		Tinder.swipe();
	};
	let exists = false;
	if ((props.userVehiclesList || []).length > 0) {
		for (var i = 0; i < props.userVehiclesList.length; i++) {
			if (!("registrationNumber" in props.userVehiclesList[i])) {
				exists = true;
				break;
			}
		}
	}
	useEffect(() => {
		fetchData();
		if (!!inputRef.current) {
			inputRef.current.value = props.serviceSearch;
		}
		if (!(props.userVehiclesList || []).length && !props.sliderCatelogVehicleId) {
			setToast({
				toastMessage: "Please add vehicles",
				showToast: true,
				severity: "warning",
			});
		}
		if (!!props.sliderCatelogVehicleId) {
			setToast({
				toastMessage: "",
				showToast: false,
				severity: "",
			});
		}
		if (exists) {
			setToast({
				toastMessage: "Please add vehicle(s) Registration Number",
				showToast: true,
				severity: "warning",
			});
		}
		return () => {
			setState([]);
			setSearchTags([]);
		};
	}, [props.sliderCatelogVehicleId, props.userAddressList]);

	const debounced = React.useRef(
		useDebouncedCallback(async (value) => {
			setSearchString(value);

			let workshopId: any = "";

			if (!!props.location) {
				if (!!props.location.state) {
					if (!!props.location.state.workshopId) {
						workshopId = props.location.state.workshopId;
					}
				}
			}

			if (workshopId === "") {
				if (localStorage.getItem("workshopId")) {
					workshopId = localStorage.getItem("workshopId");
				}
			}

			const vMake = props.userVehiclesList.find(
				(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
			);

			const response = await props.getRecommendedServices({
				catalogVehicleId: props.sliderCatelogVehicleId,
				searchString: value,
				latitude: props.addressDetails.latitude,
				longitude: props.addressDetails.longitude,
				pricingSegment: props.settings.pricingSegment,
				workshopId: workshopId,
				clientName: constants.CLIENT_NAME,
				make: vMake.make,
				tags: state.map((ele: any) => ele.tagname).join(","),
			});
			if (response && response.status && response.data.length) {
				await setSearchTags([...response.data[0].tags, "Body Panel"]);
			} else {
				await setSearchTags([]);
			}
			// if (state.length) {
			//   const data = state.pop();
			//   searchTags[data.index] = data.tagname;
			//   setSearchTags((state: any) => [...state, searchTags]);
			// }
			await setState([]);
			await props.saveServiceSearchData({
				searchString: value,
				tags: state,
			});
		}, 1000)
	);

	const fetchData = async () => {
		const addressDetails = (props.userAddressList || []).find(
			(ele: any) => ele.did === props.selectedAddressRef
		);

		console.log("BookService 141 ......", props);

		if (!!addressDetails) {
			let workshopId: any = "";

			if (!!props.location) {
				if (!!props.location.state) {
					if (!!props.location.state.workshopId) {
						workshopId = props.location.state.workshopId;
					}
				}
			}

			if (workshopId === "") {
				if (localStorage.getItem("workshopId")) {
					workshopId = localStorage.getItem("workshopId");
				}
			}

			const vMake = props.userVehiclesList.find(
				(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
			);

			const response: any =
				!!props.sliderCatelogVehicleId &&
				(await props.getRecommendedServices({
					catalogVehicleId: props.sliderCatelogVehicleId,
					searchString: props.serviceSearch,
					pricingSegment: props.settings.pricingSegment,
					workshopId: workshopId,
					tags: (props.serviceSearchTags || []).length
						? props.serviceSearchTags.map((ele: any) => ele.tagname)
						: "",
					latitude: addressDetails.latitude,
					longitude: addressDetails.longitude,
					clientName: constants.CLIENT_NAME,
					make: vMake.make,
				}));

			setSearchString(props.serviceSearch);
			if (response && response.status === "SUCCESS" && response.data.length) {
				if ((props.serviceSearchTags || []).length) {
					setState(props.serviceSearchTags);
					setSearchTags([
						...checkForSearchTags(
							response.data[0].tags,
							props.serviceSearchTags.map((ele: any) => ele.tagname)
						),
						"Body Panel",
					]);
				} else {
					setState([]);
					setSearchTags([...response.data[0].tags, "Body Panel"]);
				}
			} else {
				setSearchTags([]);
			}
		}
	};

	const checkForSearchTags = (array1: Array<any>, array2: Array<any>) => {
		const result = array1
			.map((ele: any, ind: any) => {
				if (ele !== array2[ind]) {
					return ele;
				}
			})
			.filter((ele: any) => ele);
		return result;
	};
	return (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			{isPlatform("ios") && <div className="ios_statusbar_color" />}
			<PageHeaderWithLoc {...props} />
			<div className={isPlatform("ios") ? "bs_parent top100" : "bs_parent"}>
				{Boolean((props.userVehiclesList || []).length) && (
					<div className="serchbar_parent">
						<div className="search_layout_mobile flex_one">
							<IonInput
								className="input_search_mobile"
								placeholder="Search for services"
								// value={searchString}
								ref={inputRef}
								onIonChange={(event) => debounced.current(event.detail.value)}
							/>
							<IonImg className="searchIcon_mobile" src="images/search_service.svg" />
						</div>
					</div>
				)}

				{Boolean(state.length) && (
					<div className="bs_wrapcenter ">
						{state.map((ele: any, ind: any) => {
							if (ele.tagname.toLowerCase() !== "body panel") {
								return (
									<div key={ind} className="selected_tagpill">
										<IonLabel className="selected_pill_text mg-r-5">
											{ele.tagname}
										</IonLabel>
										<IonIcon
											icon={closeOutline}
											color="light"
											onClick={async () => {
												await setState(
													state.filter((element: any) => element.tagname !== ele.tagname)
												);
												searchTags[ele.index] = ele.tagname;

												let workshopId: any = "";

												if (!!props.location) {
													if (!!props.location.state) {
														if (!!props.location.state.workshopId) {
															workshopId = props.location.state.workshopId;
														}
													}
												}

												if (workshopId === "") {
													if (localStorage.getItem("workshopId")) {
														workshopId = localStorage.getItem("workshopId");
													}
												}

												const vMake = props.userVehiclesList.find(
													(item: any) =>
														item.catalogVehicleId === props.sliderCatelogVehicleId
												);

												// await setSearchTags(searchTags);
												const response = await props.getRecommendedServices({
													catalogVehicleId: props.sliderCatelogVehicleId,
													searchString: searchString,
													pricingSegment: props.settings.pricingSegment,
													latitude: props.addressDetails.latitude,
													longitude: props.addressDetails.longitude,
													workshopId: workshopId,
													clientName: constants.CLIENT_NAME,
													make: vMake.make,
													tags: state
														.filter((element: any) => element.tagname !== ele.tagname)
														.map((ele: any) => ele.tagname)
														.join(",")
														.toString(),
												});
												if (response && response.status === "SUCCESS") {
													setSearchTags([...response.data[0].tags, "Body Panel"]);
												}
												await props.saveServiceSearchData({
													searchString,
													tags: state.filter(
														(element: any) => element.tagname !== ele.tagname
													),
												});
											}}
										/>
									</div>
								);
							}
						})}
					</div>
				)}
				{!!state.length && (
					<div className="separator_div">
						<div className="tags_separator" />
					</div>
				)}
				<div className="bs_wrapcenter">
					{(searchTags || []).map(
						(tagname: any, ind: any) =>
							!!tagname &&
							tagname.toLowerCase() !== "body panel" && (
								<div
									key={ind}
									className="bs_tagpill"
									onClick={async () => {
										if (tagname.toLowerCase() === "body panel") {
											props.history.push("/portal/body-panel");
										} else {
											let workshopId: any = "";

											if (!!props.location) {
												if (!!props.location.state) {
													if (!!props.location.state.workshopId) {
														workshopId = props.location.state.workshopId;
													}
												}
											}

											if (workshopId === "") {
												if (localStorage.getItem("workshopId")) {
													workshopId = localStorage.getItem("workshopId");
												}
											}

											const vMake = props.userVehiclesList.find(
												(item: any) =>
													item.catalogVehicleId === props.sliderCatelogVehicleId
											);

											const response = await props.getRecommendedServices({
												catalogVehicleId: props.sliderCatelogVehicleId,
												searchString: searchString,
												pricingSegment: props.settings.pricingSegment,
												latitude: props.addressDetails.latitude,
												longitude: props.addressDetails.longitude,
												workshopId: workshopId,
												clientName: constants.CLIENT_NAME,
												make: vMake.make,
												tags: [
													...state,
													{
														tagname,
														index: ind,
													},
												]
													.map((ele: any) => ele.tagname)
													.join(","),
											});
											if (response && response.status === "SUCCESS") {
												setSearchTags([...response.data[0].tags, "Body Panel"]);
												// setSearchTags(
												//   searchTags.map((ele: any, index: any) => {
												//     if (index === ind) {
												//       return "";
												//     }
												//     return ele;
												//   })
												// );
											}
											await setState([...state, { tagname, index: ind }]);
											await props.saveServiceSearchData({
												searchString,
												tags: [...state, { tagname, index: ind }],
											});
										}
									}}
								>
									<IonLabel className="bs_pill_text">{tagname}</IonLabel>
								</div>
							)
					)}
				</div>

				<IonRow className="recommende_service responsive_recommend paddBtm30">
					{(!!searchString.trim().length || !!state.length) &&
						!props.showLoader &&
						(Boolean((props.searchServices || []).length) ? (
							<>
								<IonText className="search_header search_font">
									{"Search Results"}
								</IonText>
								{(props.searchServices || []).map((record: any, index: any) => (
									<ServicePill {...record.recommended} {...props} key={index} />
								))}
							</>
						) : (
							<div className="no_results_found_container">
								<IonLabel>No Results found</IonLabel>
							</div>
						))}
					{Boolean((props.searchRecommendations || []).length) &&
					(props.userVehiclesList || []).length &&
					!exists ? (
						<>
							<IonText className="search_header search_font">
								{RECOMMENDED_SERVICES}
							</IonText>
							{(props.searchRecommendations || []).map((record: any, index: any) => (
								<ServicePill {...record.recommended} {...props} key={index} />
							))}
						</>
					) : (
						<>
							{/* <div className="flex_one">
                <IonText className="search_header">
                  {RECOMMENDED_SERVICES}
                </IonText>
                <div className="my_service_status marginleftright10">
                  <IonText className="active_service">
                    {constants.YOU_DONT_HAVE_ANY_VEHICLES_ADDED}
                  </IonText>
                  <div>
                    <IonButton
                      color="primary"
                      className="book_btn"
                      expand="block"
                      onClick={() => props.history.push("/portal/add-vehicles")}
                    >
                      {constants.ADD_A_NEW_VEHICLE}
                    </IonButton>
                  </div>
                  <IonText className="over_2k">
                    {constants.TO_SEE_LIST_OF_RECOMMENDED_SERVICES}
                  </IonText>
                </div>
                <IonCol
                  className="responsive_screen p-0"
                  size="12"
                  size-sm
                  size-md="9"
                >
                  <div
                    className="book_serivice_res"
                    onClick={() => props.history.push("/portal/add-vehicles")}
                  >
                    <IonLabel className="book_service_text" color="primary">
                      {constants.ADD_A_NEW_VEHICLE}
                      <p className="no_services">
                        {" "}
                        {constants.TO_SEE_LIST_OF_RECOMMENDED_SERVICES}
                      </p>
                    </IonLabel>
                    <IonImg
                      className="right_arrow"
                      src="/images/book_service.svg"
                    />
                  </div>
                </IonCol>
              </div> */}
							<div
								style={{
									marginTop: 20,
								}}
							>
								<ScreenBanner />
							</div>
						</>
					)}
				</IonRow>
			</div>
			{Boolean(props.service_data.length) && (
				<div className="book-service-cart-details">
					<div className="sd_col">
						<IonLabel className="sd_escost">
							{props.service_data.length} {constants.TWO_SERVICES} {constants.ADDED}
						</IonLabel>
						<IonLabel className="sd_price">{` ${constants.RupeeSymbol} ${props.cart_estimates.totalEstimated}`}</IonLabel>
					</div>
					<IonButton
						color="light"
						className="service-details-continue-button"
						onClick={() => props.history.push("/portal/cart")}
					>
						<IonLabel color="primary">{constants.CONTINUE}</IonLabel>
					</IonButton>
				</div>
			)}
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
		</IonCol>
	);
};
export default connect(
	({
		auth: { settings, selectedVehicleRef, onBoarding, defaultAddressRef },
		userInfo,
		cart: { service_data, cart_estimates },
		workshop: { globalSettings },
		loader: { showLoader },
	}: any) => {
		const {
			userVehiclesList,
			searchRecommendations,
			searchServices,
			searchTags,
			serviceSearchTags,
			serviceSearch,
			userAddressList,
			sliderCatelogVehicleId,
			selectedAddressRef,
		} = userInfo;
		return {
			settings,
			defaultAddressRef,
			onBoarding,
			userVehiclesList,
			selectedVehicleRef,
			searchRecommendations,
			searchServices,
			searchTags,
			serviceSearch,
			userAddressList,
			// ...auth,
			sliderCatelogVehicleId,
			selectedAddressRef,
			service_data,
			cart_estimates,
			globalSettings,
			showLoader,
			serviceSearchTags,
		};
	},
	{
		getRecommendedServices,
		// withSearchGetRecommendations,
		saveServiceSearchData,
		storeCurrentLatLong,
		storeUserMapAddress,
		updateVehicleDefaultAddress,
		deleteAddress,
		setDefAddress,
		saveAddressRef,
		saveWorkshopStandard,
		addItemToCart,
		getCartItemsList,
	}
)(BookService);
